{
  "schemaVersion": "1.0.0",
  "product": "Type Set",
  "principle": "A type direction earns its keep on slides, not in an isolated alphabet parade.",
  "fields": {
    "kicker": { "softCharacters": 24, "hardCharacters": 40, "multiline": false },
    "headline": { "softCharacters": 60, "hardCharacters": 90, "multiline": true },
    "subheadline": { "softCharacters": 140, "hardCharacters": 220, "multiline": true },
    "body": { "softCharacters": 360, "hardCharacters": 600, "multiline": true },
    "quote": { "softCharacters": 180, "hardCharacters": 300, "multiline": true },
    "caption": { "softCharacters": 90, "hardCharacters": 140, "multiline": true },
    "dataLabel": { "softCharacters": 32, "hardCharacters": 48, "multiline": false },
    "dataValue": { "softCharacters": 16, "hardCharacters": 24, "multiline": false }
  },
  "templates": [
    {
      "id": "cover",
      "name": "The opening",
      "job": "Prove first-impression hierarchy and title legibility.",
      "layout": "statement",
      "requiredFields": ["kicker", "headline", "subheadline"],
      "optionalFields": ["caption"],
      "imageSlots": 0,
      "rolesUsed": ["display", "body", "utility"],
      "checks": ["headline_fit", "subheadline_fit", "hierarchy"]
    },
    {
      "id": "title_body",
      "name": "The argument",
      "job": "Prove the system can carry ordinary narrative slides repeatedly.",
      "layout": "title_and_body",
      "requiredFields": ["headline", "body"],
      "optionalFields": ["kicker", "caption"],
      "imageSlots": 0,
      "rolesUsed": ["display", "body", "utility"],
      "checks": ["headline_fit", "body_fit", "reading_measure"]
    },
    {
      "id": "quote",
      "name": "The voice",
      "job": "Prove expressive type can still be read and attributed.",
      "layout": "large_quote",
      "requiredFields": ["quote", "caption"],
      "optionalFields": ["kicker"],
      "imageSlots": 0,
      "rolesUsed": ["display", "body", "utility"],
      "checks": ["quote_fit", "attribution_fit", "hierarchy"]
    },
    {
      "id": "image_text",
      "name": "Image and words",
      "job": "Prove the type holds its place beside a large image.",
      "layout": "split_image_text",
      "requiredFields": ["headline", "body"],
      "optionalFields": ["kicker", "caption"],
      "imageSlots": 1,
      "rolesUsed": ["display", "body", "utility"],
      "checks": ["headline_fit", "body_fit", "image_text_collision"]
    },
    {
      "id": "evidence_data",
      "name": "The number",
      "job": "Prove values and labels stay legible under pressure.",
      "layout": "metric_and_chart",
      "requiredFields": ["headline", "dataLabel", "dataValue"],
      "optionalFields": ["body", "caption"],
      "imageSlots": 0,
      "rolesUsed": ["display", "body", "utility"],
      "checks": ["label_fit", "value_fit", "tabular_numerals"]
    }
  ],
  "samplePacks": [
    {
      "id": "film",
      "name": "A film finding its audience",
      "fields": {
        "kicker": "A FEATURE FILM",
        "headline": "What remains after the party leaves",
        "subheadline": "A tender, difficult story about friendship, work, and the price of staying.",
        "body": "The deck must hold still images, practical production detail, and an emotional argument without treating every slide like a poster.",
        "quote": "We thought the night would make us free. It only made the choices visible.",
        "caption": "Director's note",
        "dataLabel": "SHOOT DAYS",
        "dataValue": "24"
      }
    },
    {
      "id": "project",
      "name": "A useful thing asking to exist",
      "fields": {
        "kicker": "THE PROPOSAL",
        "headline": "Make the useful decision visible",
        "subheadline": "A practical deck for people with work to do and no appetite for decorative fog.",
        "body": "The proposal needs to explain the problem, demonstrate the method, and make the work feel possible. The type should carry the argument without becoming the argument.",
        "quote": "Show the decision. Keep the evidence close.",
        "caption": "Working principle",
        "dataLabel": "TEST CASES",
        "dataValue": "30"
      }
    },
    {
      "id": "venture",
      "name": "A company with something concrete to prove",
      "fields": {
        "kicker": "SEED ROUND",
        "headline": "Infrastructure for the people already doing the invisible work",
        "subheadline": "A practical system for small teams that have outgrown spreadsheets but not their common sense.",
        "body": "The deck combines customer evidence, operating detail, market context, and a clear request. The type must survive repetition and dense slides without becoming grey soup.",
        "quote": "The work was always there. The software finally noticed it.",
        "caption": "Customer interview, Austin",
        "dataLabel": "ACTIVE TEAMS",
        "dataValue": "1,280"
      }
    },
    {
      "id": "plain",
      "name": "A plain stress test",
      "fields": {
        "kicker": "SECTION LABEL",
        "headline": "Make the next decision easier.",
        "subheadline": "A clear recommendation, enough evidence to trust it, and room for an honest question.",
        "body": "Put the recommendation where the room can see it. Keep the evidence close enough to trust, then move the furniture into the appendix.",
        "quote": "If the point is hiding, the deck is not finished.",
        "caption": "Working principle",
        "dataLabel": "HOURS SAVED EACH WEEK",
        "dataValue": "6"
      }
    }
  ]
}
